import React, { FC, useContext, useEffect } from 'react';

import { gql, useQuery } from '@apollo/client';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import LocationContext from './Context';
import { ReactComponent as IconDown } from '../assets/icons/down-arrow.svg';

interface FiltersProps {}

const StyledFilters = styled.div`
    color: #222;
`;

const GET_BRANDS = gql`
    query GetBrands {
        brands(first: 100) {
            nodes {
                databaseId
                name
            }
        }
    }
`;

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#009FE3' : '#cccccc',
        minHeight: '50px',
        borderWidth: '2px',
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '16px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),

    dropdownIndicator: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? '#888888' : '#009fe3',
        color: 'white',
        minHeight: '50px',
        minWidth: '50px',
        margin: '-2px',
        borderRadius: '3px',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        const fontSize = '16px';
        const lineHeight = '18px';

        return { ...provided, opacity, transition, lineHeight,  fontSize };
    },
};
const Filters: FC<FiltersProps> = () => {
    const { filters, setFilters } = useContext(LocationContext);

    const { loading: brandsLoading, error: brandsError, data: brandsData } = useQuery(GET_BRANDS);

    useEffect(() => {
        setFilters((state) => {
            const newState = { ...state };
            delete newState.product;

            return newState;
        });
    }, [filters?.brand, setFilters]);

    const brands =
        brandsData && brandsData.brands
            ? [
                  { value: '', label: 'Any Brand' },
                  ...brandsData.brands.nodes.map((itm) => ({ value: itm.databaseId, label: itm.name })),
              ]
            : [];

    const handleChangeFilter = (filter, value) => {
        setFilters((state) => ({
            ...state,
            [filter]: value,
        }));
        console.log({ filter, value });
    };

    const CustomOption = props => <components.Option className="needsclick" {...props} />;
    const CustomDropdownIndicator = ({ innerProps }) => <IconDown {...innerProps} />;
    return (
        <StyledFilters>
            <Select
                defaultValue={filters?.brand ? filters.brand : ''}
                value={filters?.brand ? filters.brand : ''}
                onChange={(sel) => handleChangeFilter('brand', sel)}
                options={brands}
                isClearable
                isSearchable={false}
                isLoading={brandsLoading}
                placeholder="Select a brand"
                styles={customStyles}
                components={{ DownChevron: CustomDropdownIndicator, Option: CustomOption }}
            />
            {brandsError && <p>Brands failed to load</p>}

        </StyledFilters>
    );
};

export default Filters;
